import {
	CircularProgress,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material'
import React from 'react'
import { Employee } from '../../../types/Employee/Employee'
import { StyledTableCell } from '../../core/StyledTableCell'
import { ShiftEndSupervisionRow } from './ShiftEndSupervisionRow'

type SelectForemanProps = {
	foremen: Employee[] | undefined
	postConfirmLoadData: () => void
}

export function ShiftEndSelectSupervision({ foremen, postConfirmLoadData }: SelectForemanProps) {
	return (
		<>
			{foremen ? (
				<TableContainer sx={{ height: '100%', width: '100%', overflowX: 'scroll' }}>
					<Table stickyHeader>
						<TableHead>
							<TableRow>
								<StyledTableCell align='left'>Name</StyledTableCell>
								<StyledTableCell align='center'>Time Sheet</StyledTableCell>
								<StyledTableCell align='center'>Employee Id</StyledTableCell>
								<StyledTableCell align='center'>Primary Craft</StyledTableCell>
								<StyledTableCell align='center'>Worker Class</StyledTableCell>
								<StyledTableCell align='center'>Status</StyledTableCell>
								<StyledTableCell align='center'>Report Uploaded</StyledTableCell>
							</TableRow>
						</TableHead>

						<TableBody>
							{(foremen ?? []).map((foreman: Employee) => (
								<ShiftEndSupervisionRow
									directReport={foreman}
									key={foreman.id}
									postConfirmLoadData={postConfirmLoadData}
								/>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<CircularProgress color='success' />
			)}
		</>
	)
}
